import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html,
  body {
    margin:0; padding:0; background-size:cover; background-position:center center; width:auto; height:100vh; box-sizing:border-box; 
  }

  body {
    /* font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; */
  }

:root {
    --vh:1vh;
  }

  a { text-decoration:none; cursor:pointer; }

  p,
  label {
    /* font-family: Georgia, Times, 'Times New Roman', serif; */
    line-height: 1.5em;
  }

  input, select {
    font-family: inherit;
    font-size: inherit;
  }
  ul, li{
    margin:0; padding:0; list-style:none;
  }

/* SCROLLBAR */
::-webkit-scrollbar { width:4px; height:4px; }
::-webkit-scrollbar-track { background:none; }
::-webkit-scrollbar-thumb { background:#163b6a; }

/* SELECTION */
::selection { background:#163b6a; }
-webkit-::selection { background:#163b6a; }
-moz-::selection { background:#163b6a; }
-o-::selection { background:#163b6a; }
`;
